import { createContext } from "react";

export const RequestContext = createContext();
